export default __webpack_public_path__ + "static/media/logo-mobile.46eeba23.svg";